import { defineComponent as _defineComponent } from 'vue';
import { onMounted, onUnmounted } from 'vue';
import { useSnapImage } from '@blade-sxp/monitoring-center/pages/snap/utils/useSnapImage';
import LineList from '@blade-sxp/monitoring-center/pages/snap/components/line-list.vue';
import BlockList from '@blade-sxp/monitoring-center/pages/snap/components/block-list.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const { isCollapse, showImgList, toggleCollapse, unfold, initWebSocket, closeWebSocket, mouseenter, mouseleave, handleClick } = useSnapImage();
        onMounted(() => initWebSocket());
        onUnmounted(() => closeWebSocket());
        return { __sfc: true, isCollapse, showImgList, toggleCollapse, unfold, initWebSocket, closeWebSocket, mouseenter, mouseleave, handleClick, LineList, BlockList };
    }
});
